import { useEffect, useState } from "react";

export default function useDecodedImage(src) {
  const [decodedSrc, setDecodedSrc] = useState(null);

  useEffect(() => {
    if (!src) {
      setDecodedSrc(null);
      return undefined;
    }

    if (typeof Image === "undefined") {
      setDecodedSrc(src);
      return undefined;
    }

    let cancelled = false;
    const image = new Image();

    const markReady = () => {
      if (!cancelled) setDecodedSrc(src);
    };

    const decodeThenReady = () => {
      if (typeof image.decode === "function") {
        image.decode().catch(() => {}).then(markReady);
        return;
      }
      markReady();
    };

    setDecodedSrc(null);
    image.onload = decodeThenReady;
    image.onerror = markReady;
    image.src = src;

    if (image.complete) decodeThenReady();

    return () => {
      cancelled = true;
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  return !src || decodedSrc === src;
}
